import { useEffect, useState } from 'react'
import { readDisplayPreferences, subscribeDisplayPreferences, type DisplayPreferences } from './preferences'

export function useDisplayPreferences(): DisplayPreferences {
  const [preferences, setPreferences] = useState(readDisplayPreferences)
  useEffect(() => subscribeDisplayPreferences(setPreferences), [])
  return preferences
}
